import { render, staticRenderFns } from "./BasicDataTab.vue?vue&type=template&id=b0214448&scoped=true&"
import script from "./BasicDataTab.vue?vue&type=script&lang=js&"
export * from "./BasicDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0214448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0214448')) {
      api.createRecord('b0214448', component.options)
    } else {
      api.reload('b0214448', component.options)
    }
    module.hot.accept("./BasicDataTab.vue?vue&type=template&id=b0214448&scoped=true&", function () {
      api.rerender('b0214448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/config/BasicDataTab.vue"
export default component.exports